"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _BaseSvg = require("./BaseSvg");
Object.keys(_BaseSvg).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BaseSvg[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _BaseSvg[key];
    }
  });
});
var _Caret = require("./Caret");
Object.keys(_Caret).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Caret[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Caret[key];
    }
  });
});
var _Arrow = require("./Arrow");
Object.keys(_Arrow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Arrow[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Arrow[key];
    }
  });
});